import React, { useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Divider from "../ui/Divider";
import Label, { DisplayLabel } from "../ui/Label";
import { pubCall, pubCallAsync } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import POSList from "../components/POSList";
import Input from "../ui/Input";
import Float from "../ui/Float";
import POSDetails from "../components/POSDetails";
import IconNav from "../ui/IconNav";
import Status from "../ui/Status";
import { CopyIconInv, CreateIcon, DeleteIcon, EditIconInv, ExtrasIcon, GiftIcon, HistoryIcon, LabelIcon, LogIcon, MenuPointOfSaleIcon, MessageIconInv, NewIcon, NoSaleIcon, OrderIcon, PrintIcon, QuickSalesIcon, SearchIconInv, SettingsIcon, TotalIcon, ViewIconInv, WebIcon } from "../utils/Icons";
import POSItems from "../components/POSItems";
import POSEdit from "../components/POSEdit";
import { createScreen } from "../hooks/createScreen";
import { TRANSACTION } from "../utils/Struct";
import { drawPicker } from "../popovers/Picker";
import { ENUMS } from "../utils/Enums";
import Cookies from "js-cookie";
import { drawPrice, requestClerkCode, requestPrompt, showConfirm, showInfo, showLogin, stringToFile } from "../utils/Utils";
import POSSearch from "../components/POSSearch";
import { createModal } from "../hooks/createModal";
import Spin from "../ui/Spin";
import POSTender, { pos_parsePrintOptions } from "../components/POSTender";
import { createEmpty } from "../hooks/createEmpty";
import InventoryDetails from "../components/InventoryDetails";
import { getSignal } from "../App";
import { stock_structure } from "../data_structures/Stock";
import NoSale from "../components/pos/NoSale";
import ViewFile from "../components/reconciliation/ViewFile";
import PrintOptions from "../components/PrintOptions";
import PrintOptionsWrapper from "../components/pos/PrintOptionsWrapper";
import POSTransactionLog from "../components/pos/POSTransactionLog";


export const pos_lockTransaction = (params, callback, async = false) => {
    let _obj = params;

    const endpoint = "point_of_sale.lockTransaction";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_capturePayment = ({ invoice = "", amount = 0, clerk_code = "" }, callback = () => { }, async = false) => {
    const params = {
        invoice,
        amount,
        clerk_code,
    };
    const endpoint = "point_of_sale.capturePayment";
    if (async) {
        return pubCallAsync(endpoint, params);
    }
    pubCall(endpoint, params, (_s, _r) => callback(_s, _r));
};

export const pos_lock = (params, callback, async = false) => {
    const {
        invoice = "",
        lock_status = ""
    } = params;

    let _obj = {
        invoice: invoice,
        lock_status: lock_status
    }

    if (lock_status === "M") {
        _obj.require_clerk_code = true;
    }

    const endpoint = "account_receivable.setLock";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_unLockTransaction = (params, callback, async = false) => {
    let _obj = params;

    const endpoint = "point_of_sale.unlockTransaction";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}


export const pos_getHeldsForCustomer = (params, callback, async = false) => {
    let _obj = params;

    const endpoint = "point_of_sale.getHeldsForCustomer";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}




export const pos_startNewTransaction = (params, callback = () => { }, async = false) => {

    const { header = false, item = false, check_onhands = false, employee = "" } = params
    let _obj = { header: header, check_onhands: check_onhands, clerk_code: employee }
    if (item) { _obj.item = item; }

    const endpoint = "point_of_sale.startNewTransaction";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_addItem = ({ invoice = "", check_onhands = false, item, employee = "" }, callback = () => { }, async = false) => {
    let _obj = { invoice: invoice, clerk_code: employee, item: item, check_onhands }
    const endpoint = "point_of_sale.addItem";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_editItem = ({ item, employee = "" }, callback = () => { }, async = false) => {
    let _obj = { clerk_code: employee, item: item }
    const endpoint = "point_of_sale.editItem";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_removeItem = ({ point_of_sale_id = "", employee = "" }, callback = () => { }, async = false) => {
    let _obj = { point_of_sale_id: point_of_sale_id, clerk_code: employee }
    const endpoint = "point_of_sale.removeItem";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_deleteTransaction = ({ invoice = "" }, callback = () => { }, async = false) => {
    let _obj = { invoice: invoice };
    const endpoint = "point_of_sale.deleteTransaction";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_voidTransaction = ({ invoice = "", receipt = false }, callback = () => { }, async = false) => {
    let _obj = {
        invoice: invoice,
        require_clerk_code: true,
        print_void_receipt: receipt,
    };
    const endpoint = "point_of_sale.voidTransaction";
    if (async) {
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => callback(_s, _r));
    }
}

export const pos_copyTransaction = ({ invoice = "" }, callback = () => { }, async = false) => {
    let _obj = { invoice: invoice, require_clerk_code: true };
    const endpoint = "point_of_sale.copyTransaction";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}

export const pos_editHeader = ({ header = "", employee = "" }, callback = () => { }, async = false) => {
    let _obj = { header: header, clerk_code: employee };
    const endpoint = "point_of_sale.editHeader";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}



export const pos_printTransaction = ({ invoice = "", options = "" }, callback = () => { }, async = false) => {
    let _obj = { invoice: invoice, options: options };
    const endpoint = "point_of_sale.printTransaction";
    if (async) { // return promise
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })
    }
}


// export const pos_removeItem = (params, callback = () => {}, async = false) =>{
//      let _obj = { invoice: invoice, require_clerk_code: true };
// }

export default function POSController(props) {

    const { controller = "", signal = {}, setController = () => { } } = props;

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [selectedFull, setSelectedFull] = useState({})
    const [selectedItem, setSelectedItem] = useState({});
    const [items, setItems] = useState([]);
    const [itemsRefresh, setItemsRefresh] = useState(0);
    const [align, setAlign] = useState("start");
    const row_key = "posh_id";
    const employee = useRef("");
    const [state, setState] = useState({
        edit: false,
        adding: false,
        view: "items",
        show_pos_card: true,
        new_title: false
    })

    const columnViews = [1, 2, 3, 4];
    const [columnView, setColumnView] = useState(1);
    const cycleColumnView = (_dir = 1) => {
        setColumnView((current) => {
            const index = columnViews.indexOf(current);
            return columnViews[(index + _dir) % columnViews.length];
        });
    };


    const [focus, setFocus] = useState(false)
    const returnFromInventoryRef = useRef(null);
    const callbackRef = useRef(() => { });
    const prev_row_fallback = useRef({});
    const lockedInvoiceRef = useRef("");

    const showPOSDetails = state.view === "list" || state.show_pos_card || selectedItem?.__new;






    const getPrinterSettings = () => {
        pubCall("work_station_setting.get", {}, (_s, _r) => {
            if (!_s) {
                showError(_r);
                return;
            }

            window.workstation_settings = _r;


        });
    };

    useEffect(getPrinterSettings, []);


    const getSettings = () => {

        window.pos_settings = {
            sales_started_in_field: "I",
            default_customer_linked_document_format: "I",
            default_customer_linked_on_acct_document_format: "I",
            default_customer_linked_on_acct_print_type: "P",
            default_customer_linked_print_type: "P",
            default_tender: {
                name: "OnAcct",
                number: "K"
            },
            default_tender_customer: {
                name: "Cheque",
                number: "J"
            },
            offsite_customer: "",
            offsite_group: "",
            offsite_z_clerk: false,
            sales_started_in_field: "S",
            station_edit_other_groups: false,
            station_group: "99",
            warn_customer_sold_duplicate: true
        }

        setLoading(true)
        pubCall("setting.point_of_sale.getSettings", {}, (_s, _r) => {
            if (_s) {
                console.log("SETTINGS", _r)
                window.pos_settings = _r;

            } else {
                showError(_r);
            }
            setLoading(false)
        });
    };

    useEffect(getSettings, []);


    useEffect(() => {
        return () => {
            const invoice = lockedInvoiceRef.current;

            if (invoice) { pos_unLockTransaction({ invoice }, () => { }); lockedInvoiceRef.current = ""; }
        };
    }, []);


    const unlockTransaction = (callback = () => { }) => {
        const invoice = lockedInvoiceRef.current;

        if (!invoice) {
            callback();
            return;
        }

        pos_unLockTransaction({ invoice }, (_s, _r) => {
            if (!_s) {
                showError(_r || {
                    error: "Unable to unlock transaction"
                });
            }

            lockedInvoiceRef.current = "";
            callback();
        });
    };

    const finishEditing = (nextState = {}) => {
        unlockTransaction(() => {
            window.bm_state.value = ROUTES.POS.POS;

            setState(s => ({
                ...s,
                edit: false,
                adding: false,
                view: "items",
                ...nextState,
            }));
        });
    };


    const toggleDetailCard = () => {
        if (selectedItem?.__new) {
            setState(s => ({ ...s, show_pos_card: true }));
            return;
        }

        setState(s => ({
            ...s,
            show_pos_card: !s.show_pos_card,
        }));
    };

    const toggleView = () => {
        if (state.view === "list") {
            // window.bm_state.value = ROUTES.POS.ITEMS;
            setState(s => ({ ...s, view: "items", show_pos_card: true }));
        } else {
            window.bm_state.value = ROUTES.POS.POS;
            setState(s => ({ ...s, view: "list", show_pos_card: true }));

        }

    };

    const copyTransaction = (_transaction = selected) => {
        setLoading(true);
        pos_copyTransaction({ invoice: _transaction?.invoice }, (_s, _r) => {
            if (_s) {
                Cookies.set("pos_id", _r.posh_id);
                fetch()
            } else {
                showError(_r);
            }
        })
    }

    const deleteTransaction = (_transaction = selected, callback = () => { }) => {

        if (_transaction?.stage === "History") {
            showError({ error: "Can't delete a History transaction (it has been totalled off)" });
            return;
        }

        const is_void = (_transaction?.stage === "Current");
        const is_held = (_transaction?.stage === "Held");

        // A Held transaction with a processed pinpad payment can't be deleted - the payment must be voided first
        if (is_held && !_transaction?.__pinpad_checked) {
            pubCall("point_of_sale.getHeaderExtras", { invoice: _transaction?.invoice }, (_s, _r) => {
                if (!_s) {
                    showError(_r);
                    return;
                }
                if (_r?.has_captured_payments || _r?.header?.has_captured_payments) {
                    showInfo({
                        controller: controller,
                        type: "error",
                        route: window.bm_state.value,
                        title: "Can't delete.",
                        width: 400,
                        description: <div style={{ "lineHeight": "18px" }}>
                            This Held transaction contains a Pinpad payment.
                            <div className="shim" />
                            You must <strong>[E]</strong>dit, then highlight and <strong>[D]</strong>elete (void) the payment.
                        </div>,
                    });
                    return;
                }
                deleteTransaction({ ..._transaction, __pinpad_checked: true }, callback);
            })
            return;
        }

        showConfirm({
            controller: controller,
            route: ROUTES.POS.POS,
            description: <div style={{ "textAlign": "center" }}>Delete this {(is_void) ? "(Void) " : ""}<em>{_transaction?.stage || ""}</em> transaction?</div>,
            title: "Warning",
            callback: (e) => {
                if (e) {

                    if (is_void) {
                        // Void + Ask for receipt...
                        showConfirm({
                            controller: controller,
                            route: ROUTES.POS.POS,
                            description: <div style={{ "textAlign": "center" }}>Do you want a VOID receipt to attach to the original receipt?</div>,
                            callback: (_receipt) => {
                                pos_voidTransaction({ invoice: _transaction?.invoice, receipt: _receipt }, (_s, _r) => {
                                    if (_s) {
                                        showMessage("Transaction deleted.")
                                        const ind = data.findIndex(item => item[row_key] === _transaction?.[row_key]);
                                        const updated = [...data];
                                        updated[ind] = _r?.extras?.header || {};
                                        setData(updated);
                                        setSelected(updated[ind]);
                                    } else {
                                        showError(_r);
                                    }
                                    callback(_r)
                                })

                            }
                        })

                    }

                    if (is_held) {
                        // Delete
                        pos_deleteTransaction({ invoice: _transaction?.invoice }, (_s, _r) => {
                            if (_s) {
                                showMessage("Transaction deleted.")
                                const updated = data.filter(item => item[row_key] !== _transaction?.[row_key])
                                const deleted = data.findIndex(row => row[row_key] === _transaction?.[row_key]);
                                setData(updated);
                                setSelected(updated[deleted - 1] || updated[0] || {});
                            } else {
                                showError(_r);
                            }
                            callback(_r)
                        })
                    }

                }
            }
        })
    }


    const previewFile = (_text) => {

        console.log(_text);

        window.bm_state.value = ROUTES.POS.PREVIEW_FILE;
        createModal({
            component: <ViewFile controller={controller} text={_text} route={ROUTES.POS.PREVIEW_FILE} />, title: "Print preview", closable: true, callback: (_r) => {
                if (_r) {

                }
                window.bm_state.value = ROUTES.POS.ITEMS;
            }
        })
    }

    const printItem = (_str) => {
        stringToFile("file", _str, "txt");
    }

    const showTender = (header) => {

        const return_route = window.bm_state.value;
        window.bm_state.value = ROUTES.POS.TENDER;


        createScreen({
            signal: getSignal(),
            component: <POSTender controller={controller} employee={employee?.current || ""} header={header} items={items} invoice={header?.invoice} route={ROUTES.POS.TENDER} />, closable: false, title: "Select Customer",
            callback: (_obj) => {

                // Payments captured in the tender add item rows - reload the items list
                setItemsRefresh(n => n + 1);

                if (_obj === "exit") {
                    finishEditing();
                    window.bm_state.value = return_route;
                    return;
                }

                if (_obj) {

                    if (_obj?.print_previews?.length) {
                        _obj.print_previews.forEach(element => {
                            printItem(element?.data || "");
                            previewFile(element?.data || "");
                            console.log("TEXT", element)
                        });
                    }

                    window.bm_state.value = ROUTES.POS.POS;
                    // The invoice changes on completion - finalize returns { extras, print_previews } (no top-level invoice), so use the new header's
                    const _new = { ..._obj?.extras?.header, "flag": true, invoice: _obj?.extras?.header?.invoice || _obj?.invoice };
                    setItems(_obj?.extras?.items_first)
                    // "flag" skips the getHeaderExtras refetch, so use the extras returned by finalize - POSItems reads its
                    // header from here, and the new header makes it reload the items (last rows, including those just added)
                    setSelectedFull({ ...(_obj?.extras || {}), header: _new });
                    finishEditing();

                    // Completing replaces the transaction (new invoice) - drop the old row so it can't be arrowed to
                    const isOld = (row) =>
                        (header?.[row_key] && row?.[row_key] === header[row_key]) ||
                        (header?.invoice && row?.invoice === header.invoice);
                    let _d = data.filter(row => !isOld(row));
                    _d.push(_new)
                    setData(_d);
                    setSelected(_new);

                    return;
                }

                window.bm_state.value = return_route;
                setFocus(!focus);

                // if (selected?.[row_key]) {
                //     setSelected((data.length > 0) ? data[data.length - 1] : {});
                // }

            }
        });


    }


    const [titleEdit, setTitleEdit] = useState(false);




    const editTitle = (callback = () => { }) => {

        callbackRef.current = callback;

        returnFromInventoryRef.current = {
            route: window.bm_state.value,
            state: {
                view: state.view,
                show_pos_card: state.show_pos_card,
                edit: state.edit,
                adding: state.adding,
            },
        };

        window.bm_state.value = ROUTES.INVENTORY.EDIT;

        setState(s => ({
            ...s,
            show_pos_card: false,
            new_title: false,
        }));
        setTitleEdit(true);
    };

    const addTitle = (_item, callback = () => { }) => {

        callbackRef.current = callback;

        pubCall("title_link.search", { limit: 1, term: _item.primary_code, type: "isbn", scope: "both", sort: "rank" }, (_s, _r) => {

            returnFromInventoryRef.current = {
                route: window.bm_state.value,
                state: {
                    view: state.view,
                    show_pos_card: state.show_pos_card,
                    edit: state.edit,
                    adding: state.adding,
                },
            };

            window.bm_state.value = ROUTES.INVENTORY.EDIT;
            if (_r?.rows?.length) {
                setState({ ...state, show_pos_card: false, new_title: _r.rows[0]?.title_link || { ...stock_structure } })
            } else {
                setState({ ...state, show_pos_card: false, new_title: { ...stock_structure, "primary_code": _item.primary_code } })
            }

            setTitleEdit(true);
        })

    }

    const closeEdit = (stock = false) => {
        const returnState = returnFromInventoryRef.current;

        if (!returnState) {
            setTitleEdit(false);
            setState(s => ({
                ...s,
                show_pos_card: true,
                new_title: null,
            }));
            return;
        }

        window.bm_state.value = returnState.route;

        setTitleEdit(false);

        setState(s => ({
            ...s,
            ...returnState.state,
            new_title: null,
        }));

        returnFromInventoryRef.current = null;
        callbackRef.current(stock);
        callbackRef.current = () => { };

    };


    const drawNoSale = () => {



        const return_route = window.bm_state.value;

        requestClerkCode({
            signal: { value: getSignal() },
            route: return_route, callback: (e) => {
                if (e) {
                    window.bm_state.value = ROUTES.POS.NO_CASH;
                    createModal({
                        title: "Open cash drawer",
                        component: <NoSale clerk_code={e} controller={controller} route={ROUTES.POS.NO_CASH} />, closable: true, callback: (e) => {
                            window.bm_state.value = return_route;
                            if (e) {
                                showMessage("No cash transaction created")
                                Cookies.set("pos_id", e.posh_id);
                                fetch();
                            }
                        }
                    })
                }
            }
        })


    }


    const printTransaction = () => {
        const return_route = window.bm_state.value;
        window.bm_state.value = ROUTES.POS.PRINT_EDIT;
        createModal({
            component: <PrintOptionsWrapper
                header={selected}
                controller={controller}
                route={ROUTES.POS.PRINT_EDIT}
            />, closable: true, title: "Print transaction",
            callback: (result) => {
                if (result) {

                    const options = {
                        sort: "I",
                        print_options: pos_parsePrintOptions(
                            result.rows,
                            result.printSettings
                        )
                    };

                    pos_printTransaction(
                        { invoice: selected.invoice, options },
                        (_s, _r) => {
                            if (_s) {
                                showMessage("Printed");
                            } else {
                                showError(_r);
                            }
                        }
                    );
                }
                window.bm_state.value = return_route
            }
        });

    }


    const showTransactionLog = () => {
        if (!selected?.invoice || selected?.flag) {
            showError({
                error: "Select a saved transaction first.",
            });
            return;
        }

        const returnRoute = window.bm_state.value;

        window.bm_state.value = ROUTES.POS.TRANSACTION_LOG;

        createModal({
            title: "POS Transaction Log",
            closable: true,
            mask_close: false,
            component: (
                <POSTransactionLog
                    controller={controller}
                    route={ROUTES.POS.TRANSACTION_LOG}
                    invoice={selected.invoice}
                    lockTransaction={pos_lock}
                    onUpdated={extras => {
                        setSelectedFull(extras);
                    }}
                />
            ),
            callback: (result) => {
                window.bm_state.value = returnRoute;
                if (result?.refresh) {
                    fetch();
                }
            },
        });
    };


    const pos_nav = [
        { key: KBD.ESCAPE, action: () => { setController("home") } },
        { key: KBD.C, text: "Copy", icon: <CopyIconInv />, action: () => copyTransaction() },
        { key: KBD.D, text: "Delete", icon: <DeleteIcon />, action: () => deleteTransaction() },
        { key: KBD.E, text: "Edit", icon: <EditIconInv />, action: () => editTransaction() },
        { key: KBD.ALT_E, text: "@Edit", icon: <CreateIcon />, disabled: true, action: () => { } },
        { key: KBD.ARROW_LEFT, action: () => cycleColumnView(-1) },
        { key: KBD.ARROW_RIGHT, action: () => cycleColumnView(1) },
        { text: "Gift Receipt", icon: <GiftIcon />, disabled: true },
        { text: "History", icon: <HistoryIcon />, disabled: true },
        { key: KBD.L, text: "Log", icon: <LogIcon />, action: () => showTransactionLog() },
        { text: "Misc", icon: <ExtrasIcon />, disabled: true },
        { key: KBD.N, text: "New", icon: <NewIcon />, action: () => newTransaction() },
        { key: KBD.P, text: "Print", icon: <PrintIcon />, action: () => printTransaction() },
        { text: "Quick Sales", icon: <QuickSalesIcon />, disabled: true },
        { key: KBD.S, text: "Search", icon: <SearchIconInv />, action: () => showSearch() },
        { key: KBD.T, text: "Total", icon: <TotalIcon />, disabled: true },
        { text: "Extras", icon: <ExtrasIcon />, disabled: true },
        { text: "Web", icon: <WebIcon />, disabled: true },
        { key: KBD.Z, text: "No Sale", icon: <NoSaleIcon />, action: () => drawNoSale() },
        { key: KBD.V, text: "View", icon: <ViewIconInv />, action: () => toggleView() },
    ]

    useEffect(() => {
        window.bm_state.value = ROUTES.POS.POS;
    }, [])

    useEffect(() => {

        const cleanup = listen(controller, ROUTES.POS.POS, pos_nav);
        return cleanup;
    }, [pos_nav, state])


    useEffect(() => {
        if (selected?.[row_key]) {
            Cookies.set("pos_id", selected?.[row_key]);
        }
    }, [selected])





    const showSearch = () => {
        window.bm_state.value = ROUTES.POS.SEARCH;
        createModal({

            component: <POSSearch controller={controller} setSelected={setSelected} selected={selected} route={ROUTES.POS.SEARCH} />, closable: true, title: "POS Search",
            callback: (e, _searchMsg) => {
                if (e?.posh_id) {
                    Cookies.set("pos_id", e.posh_id);
                    fetch();
                }
                window.bm_state.value = ROUTES.POS.POS
            }
        });
    }


    // useEffect(() => {

    //     if (!selected?.invoice || state.view !== "list") { return; }

    //     pubCall("point_of_sale.getSingleHeader", { invoice: selected?.invoice }, (_s, _r) => {
    //         if (_s) {
    //             setData(prev =>
    //                 prev.map(row =>
    //                     row[row_key] === _r[row_key]
    //                         ? { ...row, name: "New Name" }
    //                         : row
    //                 )
    //             );
    //         } else {
    //             showError(_r);
    //         }
    //     })

    // }, [selected?.invoice])




    const newTransaction = () => {


        const _focus = window.pos_settings.sales_started_in_field || "I";

        prev_row_fallback.current = selected || {};

        requestClerkCode({
            route: window.bm_state.value,
            login: false,
            use_login: false,
            signal: signal,
            title: "Login required",
            callback: (e) => {
                if (e) {
                    // set employee

                    employee.current = e;
                    const customer = _focus === "S";
                    window.bm_state.value = ROUTES.POS.EDIT;
                    const transaction = { ...TRANSACTION };

                    setSelected(transaction.header);
                    setSelectedFull({ header: transaction.header, items_first: [] })
                    setTimeout(() => {
                        window.bm_state.value = (customer) ? ROUTES.POS.CUSTOMER : ROUTES.POS.EDIT;
                        setState({ ...state, view: customer ? "customer" : "items", edit: true, adding: true })
                    }, 10)
                }
            }
        })
    }


    const editHeader = () => {
        alert("TODO")
    }


    const editTransaction = () => {

        if (selected?.stage === "History") {
            showError({
                error: "Can't alter a History transaction (it has been totalled off)"
            });
            return;
        }

        // A new transaction without an invoice does not need locking.
        if (!selected?.invoice) {
            requestClerkCode({
                route: window.bm_state.value,
                login: false,
                use_login: false,
                signal,
                title: "Login required",
                callback: (e) => {
                    if (!e) return;

                    employee.current = e;
                    window.bm_state.value = ROUTES.POS.EDIT;

                    setState(s => ({
                        ...s,
                        view: "items",
                        edit: true,
                        adding: false,
                        show_pos_card: true,
                    }));
                }
            });

            return;
        }

        pos_lockTransaction(
            { invoice: selected.invoice },
            (_s, _r) => {
                if (!_s || !_r) {
                    showError(_r || {
                        error: "Transaction is locked"
                    });
                    return;
                }

                lockedInvoiceRef.current = selected.invoice;

                requestClerkCode({
                    route: window.bm_state.value,
                    login: false,
                    use_login: false,
                    signal,
                    title: "Login required",
                    callback: (e) => {
                        // The transaction was already locked, so release it
                        // when the login prompt is cancelled.
                        if (!e) {
                            unlockTransaction();
                            return;
                        }

                        employee.current = e;
                        window.bm_state.value = ROUTES.POS.EDIT;

                        setState(s => ({
                            ...s,
                            view: "items",
                            edit: true,
                            adding: false,
                            show_pos_card: true,
                        }));
                    }
                });
            }
        );
    };


    const getSelectedFull = () => {
        if (!selected?.invoice || selected?.flag) {
            return;
        }
        pubCall("point_of_sale.getHeaderExtras", { invoice: selected?.invoice }, (_s, _r) => {
            if (_s) {
                setSelectedFull(_r);
            } else {
                showError(_r)
            }
        })
    }
    useEffect(getSelectedFull, [selected])


    const saveAsQuote = (_ref, _return_route) => {
        // key gets changed...
        const old_row_key = selected?.[row_key];

        pubCall("point_of_sale.saveAsQuote", { invoice: selected?.invoice, clerk_code: employee?.current }, (_s, _r) => {

            if (_s) {
                showMessage("Saved as quote");
                updateTransaction(_r.header, old_row_key);
                setItems(_r.items);
                finishEditing();
            } else {
                showError(_r);
                window.bm_state.value = _return_route;
                if (_ref && typeof _ref?.focus === "function") {
                    _ref.focus();
                }
            }
        }
        );
    };

    const saveAsHeld = (_ref, _return_route, has_captured = false) => {


        if (!has_captured) {
            finishEditing();
            return;
        }

        // A processed pinpad payment (partial tender) is attached to this transaction
        showConfirm({
            controller: controller,
            route: _return_route,
            title: "Warning: Processed Pinpad Payment",
            width: 420,
            description: <div style={{"width" : "420px"}}>
                This transaction contains a processed Pinpad payment.
                <div className="shim" /><div className="shim" />
                If you save it as Held without completing the sale today, the payment will be included in your Pinpad batch but will not appear in your Bookmanager totals. 
                <div className="shim" /><div className="shim" />
                The payment will remain attached to this Held transaction until the sale is completed.
                <div className="shim" /><div className="shim" />
                <strong>Are you sure you want to save this transaction as Held?</strong>
            </div>,
            callback: (e) => {
                if (e) {
                    finishEditing();
                } else {
                    window.bm_state.value = _return_route;
                    if (_ref && typeof _ref?.focus === "function") {
                        _ref.focus();
                    }
                }
            }
        })
    }

    const cancelEdit = (_ref, _return_route) => {


        if (!selected?.invoice) {
            // not created yet
            window.bm_state.value = ROUTES.POS.POS;
            setState({ ...state, edit: false, adding: false, view: "items" });
            setSelected(prev_row_fallback.current);
            return
        }


        if (_ref && typeof _ref?.blur === "function") {
            _ref.blur();
        }

        const openPicker = (has_captured = false) => drawPicker({
            controller: controller,
            value: "R", title: "Select Status", closeable: true, height: 300, ref: null,
            close: () => {
                window.bm_state.value = _return_route;
                if (_ref && typeof _ref?.focus === "function") {
                    _ref.focus();
                }

            },
            callback: (e) => {

                // Quote and Delete are disabled when a pinpad payment exists - treat as Resume
                if (has_captured && (e === "Q" || e === "D")) {
                    e = "R";
                }

                switch (e) {
                    case "R":
                        window.bm_state.value = _return_route;
                        if (_ref && typeof _ref?.focus === "function") {
                            _ref.focus();
                        }
                        return;
                        break;
                    case "H":
                        saveAsHeld(_ref, _return_route, has_captured);
                        return;
                    case "Q":
                        saveAsQuote(_ref, _return_route);
                        return;
                        // showError({ error: "TODO - Convert to Quote" })
                        // window.bm_state.value = _return_route;
                        // if (_ref && typeof _ref?.focus === "function") {
                        //     _ref.focus();
                        // }
                        break;
                    case "D":
                        unlockTransaction(() => {
                            deleteTransaction(selected, () => {
                                window.bm_state.value = ROUTES.POS.POS;

                                setState(s => ({
                                    ...s,
                                    edit: false,
                                    adding: false,
                                    view: "items",
                                }));
                            });
                        });
                        return;
                        break;
                }



            }, offset: [0, 10],
            options: ENUMS.TRANSACTION_INTERUPTED.map(item => {
                if (!has_captured) return item;
                if (item.value === "Q") return { ...item, label: "Can't save as Quote (Pinpad payment exists)", disabled: true };
                if (item.value === "D") return { ...item, label: "Can't delete (Pinpad payments exist)", disabled: true };
                return item;
            })
        })

        // has_captured_payments comes back at the top level of the extras response (beside header / items_total)
        const hasCaptured = (_extras = {}) => !!(_extras?.has_captured_payments || _extras?.header?.has_captured_payments);

        // Fetch the extras first so a payment captured during this edit (partial tender) is reflected
        pubCall("point_of_sale.getHeaderExtras", { invoice: selected?.invoice }, (_s, _r) => {
            if (_s) {
                setSelectedFull(_r);
                openPicker(hasCaptured(_r));
            } else {
                openPicker(hasCaptured(selectedFull));
            }
        })
    }


    const fetchLast = (_filters = {}) => {
        setLoading(true);
        pubCall("point_of_sale.getLastHeader", _filters, (_s, _r) => {
            if (_s) {
                if (_r.length > 0) {
                    setAlign("end");
                }
                setData(_r);
                setSelected((_r.length > 0) ? _r[_r.length - 1] : {})

            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const viewTransaction = (posh_id) => {
        if (!posh_id) return;
        unlockTransaction(() => {
            window.bm_state.value = ROUTES.POS.POS;
            setState(s => ({ ...s, edit: false, adding: false, view: "items", show_pos_card: true, }));
            setLoading(true);

            pubCall("point_of_sale.getInitialHeader", { posh_id, limit: 45 }, (_s, _r) => {
                if (_s) {
                    const rows = [...(_r.rows_previous || []), ...(_r.rows_next || [])];
                    setData(rows);
                    setSelected(
                        rows.find(row => row.posh_id === posh_id) ||
                        _r.rows_next?.[0] ||
                        _r.rows_previous?.at(-1) ||
                        {}
                    );
                    setAlign("auto");
                } else {
                    showError(_r);
                }
                setLoading(false);
            });
        });
    }

    const fetch = () => {
        if (loading || state.edit) { return }

        let _filters = {};
        _filters.limit = 45;
        if (selected?.[row_key]) {
            _filters[row_key] = selected?.[row_key];
        }

        // remember the last one...
        if (Cookies.get("pos_id")) {
            setLoading(true);
            _filters.posh_id = Cookies.get("pos_id");
            // _filters.posh_id = "019df99a-3b37-72b4-b7b4-5d24666670b8"
            pubCall("point_of_sale.getInitialHeader", _filters, (_s, _r) => {
                if (_s) {



                    setData(_r.rows_previous.concat(_r.rows_next));
                    setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : (_r.rows_previous.length > 0) ? _r.rows_previous[_r.rows_previous.length - 1] : {})


                } else {
                    fetchLast(_filters);
                }
                setLoading(false)
            })
        } else {
            fetchLast(_filters);
        }

    }

    useEffect(fetch, []);



    const updateTransaction = (header, old_row_key = selected?.[row_key]) => {
        setData(prev => prev.map(row => row[row_key] === old_row_key ? header : row));
        setSelected(header);
        setSelectedFull(prev => ({ ...prev, header }));
    };

    const stock_edit = window.bm_state.value === ROUTES.INVENTORY.EDIT;


    return (
        <div className="controller">

            <Spin loading={loading} className="bm-layout">
                <div className="bm-details">

                    {showPOSDetails ? (
                        <POSDetails
                            viewTransaction={viewTransaction}
                            updateRow={updateTransaction}
                            employee={employee?.current}
                            controller={controller}
                            selected={(selected?.[row_key] === selectedFull?.header?.[row_key]) ? selectedFull?.header : selected}
                            items_total={selectedFull?.items_total}

                            setSelected={(_header) => {

                                setSelectedFull({ ...selectedFull, "header": _header })
                            }}
                            selectedItem={selectedItem}
                            state={state}
                            setState={setState}
                            cancelEdit={cancelEdit}
                        />
                    ) : (
                        <InventoryDetails
                            edit={titleEdit}
                            new_obj={state.new_title}
                            isnew={!!state.new_title}
                            {...selectedItem}
                            switchEdit={(stock) => closeEdit(stock)}
                        />
                    )}

                </div>
                <div className="bm-list-area">



                    <POSList
                        row_key={row_key}
                        controller={controller}
                        loading={loading}
                        setLoading={setLoading}
                        route={ROUTES.POS.POS}
                        data={data}
                        setData={setData}
                        selected={selected}
                        setSelected={setSelected}
                        signal={signal}
                        align={align}
                        setAlign={setAlign}
                        state={state}
                        setState={setState}
                    />


                    {((state?.view === "items" || state?.view === "customer") &&
                        <POSItems
                            refreshKey={itemsRefresh}
                            columnView={columnView}
                            fetch={fetch}
                            removeTransaction={(invoice) => {
                                setData(prev => {
                                    const deleted = prev.findIndex(row => row.invoice === invoice);
                                    const updated = prev.filter(row => row.invoice !== invoice);
                                    setSelected(updated[deleted - 1] || updated[0] || {});
                                    return updated;
                                });
                            }}
                            closeEdit={closeEdit}
                            focus={focus}
                            editTitle={editTitle}
                            addTitle={addTitle}
                            setSelectedItem={setSelectedItem}
                            editTransaction={editTransaction}
                            toggleView={toggleView}
                            showTender={showTender}
                            employee={employee?.current}
                            header={selectedFull?.header || (selected?.header || {})}
                            items={items}
                            setItems={setItems}
                            setHeader={setSelected}
                            controller={controller}
                            updateTransaction={updateTransaction}

                            addNewRow={(item) => {
                                console.log("ITEM", item)
                                setData(prev =>
                                    prev.some(row => row.invoice === item.invoice)
                                        ? prev.map(row => row.invoice === item.invoice ? item : row)
                                        : [...prev, item]
                                );
                            }}
                            state={state}
                            setState={setState}
                            loading={loading}
                            setLoading={setLoading}
                            route={ROUTES.POS.EDIT}
                            signal={signal}
                            cancelEdit={cancelEdit}
                        />
                    )}

                </div>

                {(!state.adding && !state.edit) &&
                    <div className="bm-footer">


                        <div style={{ flex: "0 0 auto" }}>
                            <Space style={{ "padding": "0px" }}>
                                <IconNav nav={pos_nav} />
                            </Space>
                        </div>
                    </div>
                }


                {(selected?.flag &&

                    <div style={{ "position": "absolute", "bottom": "50px", "right": "0px", "width": "400px" }}>
                        <Card secondary style={{ "width": "auto", "padding": "5px 15px", "height": "94px", "backgroundColor": "var(--card-bg)", "borderRadius": "5px", "border": "2px solid var(--text-purple)" }}>
                            <Label style={{ "color": "var(--text)" }}>{<>Transaction complete</>}</Label>
                            <div style={{ "fontSize": "55px", "textAlign": "right", "fontWeight": "bold" }}>${drawPrice(selectedFull?.header?.calculated_totals?.total, true)}</div>
                        </Card>
                    </div>
                )}


            </Spin>
        </div>
    )
}
